<div class="advisor-widget-container">
  <button class="advisor-button"
          mat-flat-button
          color="primary"
          [class.active]="isExpanded"
          (click)="toggleWidget()">
    <span *ngIf="!isExpanded">
      <mat-icon class="advisor-icon">perm_phone_msg</mat-icon>
      Contact Us
    </span>
    <span *ngIf="isExpanded">✕</span>
  </button>

  <div class="advisor-widget-wrapper"
       [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'">
    <div class="advisor-content"
         *ngIf="isExpanded">
      <ifbp-advisor-widget class="advisor"
                           [data]="data">
      </ifbp-advisor-widget>
    </div>
  </div>
</div>
